import { Preview } from "@creatomate/preview";
import { ElementSource, Subtitle } from "chq";
import loadSubtitleSections from "./loadSubtitleSections";

const loadNewSubtitle = async (
  newSubtitles: Subtitle[],
  subtitles: Subtitle[],
  organization: string,
  preview: Preview,
  originalTrimStart: number,
  handleUpdateData: (data: ElementSource) => void,
  isTheOriginal: boolean,
  language?: string,
  isNewSubtitle = true
): Promise<void> => {
  let loadedSubtitles: Subtitle[] = [...subtitles];
  for (let index = 0; index < newSubtitles.length; index += 1) {
    const newSubtitle: Subtitle = newSubtitles[index];
    const existingSubtitleIndex = subtitles.findIndex(
      subtitle => newSubtitle.id === subtitle.id
    );

    // videoCreator.subtitles[existingSubtitleIndex]?.deleted means the subtitle was
    // deleted in this same edition
    if (existingSubtitleIndex === -1
      || (subtitles[existingSubtitleIndex]?.deleted
        && newSubtitle.default)) {
      // eslint-disable-next-line no-await-in-loop
      const response = await fetch(newSubtitle.url);
      // eslint-disable-next-line no-await-in-loop
      const text = await response.text();

      const subtitle = { ...newSubtitle, text };

      if (existingSubtitleIndex === -1) {
        loadedSubtitles.push(subtitle);
      } else {
        loadedSubtitles = subtitles.map((subtitle, index) => {
          if (index === existingSubtitleIndex) return subtitle;
          return { ...subtitle, active: false };
        });
        handleUpdateData({ subtitles: loadedSubtitles });
      }
      // eslint-disable-next-line no-await-in-loop
      await loadSubtitleSections(
        loadedSubtitles,
        subtitle,
        true,
        preview,
        organization,
        originalTrimStart,
        handleUpdateData,
        language,
        false,
        isNewSubtitle,
        isTheOriginal
      );
    }
  }
};

export default loadNewSubtitle;
